import { Button } from '../../../ui/button';
import { DatePicker } from '../../../ui/date-picker';
import { DialogBody, DialogFooter } from '../../../ui/dialog';
import { Label } from '../../../ui/label';

interface WizardInfoStepProps {
	acceptDeadline: Date | null;
	setAcceptDeadline: (date: Date | null) => void;
	onNext: () => void;
	onCancel: () => void;
}

export function WizardInfoStep({
	acceptDeadline,
	setAcceptDeadline,
	onNext,
	onCancel,
}: WizardInfoStepProps) {
	return (
		<div
			key="info"
			className="flex min-h-0 flex-1 animate-in fade-in-0 slide-in-from-right-2 flex-col duration-200"
		>
			<DialogBody>
				<div className="flex flex-col gap-4">
					<div className="flex flex-col gap-1.5">
						<Label>Accept deadline</Label>
						<DatePicker
							value={acceptDeadline}
							onChange={(d) => setAcceptDeadline(d ?? null)}
							placeholder="Select date"
							minDate={new Date()}
						/>
						<div className="flex gap-1.5 pt-1">
							{[
								{ label: '3 days', days: 3 },
								{ label: '1 week', days: 7 },
								{ label: '2 weeks', days: 14 },
							].map((opt) => (
								<button
									key={opt.days}
									type="button"
									onClick={() => {
										const d = new Date();
										d.setDate(d.getDate() + opt.days);
										setAcceptDeadline(d);
									}}
									className="rounded-md border border-line-2 bg-surface-input px-2 py-0.5 text-xs text-text-3 transition-colors hover:border-line-3 hover:text-text-1"
								>
									{opt.label}
								</button>
							))}
						</div>
					</div>
				</div>
			</DialogBody>
			<DialogFooter>
				<Button variant="outline" onClick={onCancel}>
					Cancel
				</Button>
				<Button onClick={onNext}>Next</Button>
			</DialogFooter>
		</div>
	);
}
